import { render } from "./Account.vue?vue&type=template&id=40473c3e&scoped=true&bindings={}"
import script from "./Account.vue?vue&type=script&lang=ts"
export * from "./Account.vue?vue&type=script&lang=ts"

import "./Account.vue?vue&type=style&index=0&id=40473c3e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-40473c3e"

export default script